export default __webpack_public_path__ + "components/weather-icon/static/dayheavyrain@3-e62f515fe4fe5a42d757f70c67920f68.png";